var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-detail"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.titleText)+" ")]),_c('div',{staticClass:"line"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }